import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

/**
 * Guard de Metadatos
 * Maneja el título de la página y las meta tags del head
 */
export const metaGuard = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  // Configurar título de la página
  document.title = to.meta.title ? `${to.meta.title} - Munzen` : 'Munzen';

  // Manejar meta tags
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta?.metaTags);

  // Eliminar etiquetas meta viejas
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).forEach(el =>
    el.parentNode?.removeChild(el),
  );

  // Añadir nuevas etiquetas meta si existen
  if (nearestWithMeta?.meta?.metaTags && Array.isArray(nearestWithMeta.meta.metaTags)) {
    (nearestWithMeta.meta.metaTags as Array<Record<string, string>>).forEach(tagDef => {
      const tag = document.createElement('meta');
      Object.entries(tagDef).forEach(([key, value]) => {
        if (value && key !== 'content') {
          tag.setAttribute(key, value as string);
        }
      });
      if (tagDef.content) {
        tag.setAttribute('content', tagDef.content);
      }
      tag.setAttribute('data-vue-router-controlled', '');
      document.head.appendChild(tag);
    });
  }

  // Continuar la navegación
  next();
};
